import styled from "@emotion/styled";
import { Avatar, Grid } from "@material-ui/core";

export const EmailCol = styled(Grid)`
  @media (max-width: 1280px) {
    padding-right: 2rem;
  }
`;
export const ListActions = styled(Grid)`
  display: flex;
  justify-content: space-between;
  padding-right: 0.5rem !important;

  @media (max-width: 1280px) {
    .MuiIconButton-edgeEnd {
      position: absolute;
      top: 1rem;
      right: 0.5rem;
    }
  }
`;
export const ReviewerImage = styled(Avatar)`
  width: 34px;
  height: 34px;
  margin: 0 1rem 0 0;
`;
export const ReviewerImageWrapper = styled.div`
  display: flex;
  align-items: center;
`;
